import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ClipLoader from 'react-spinners/ClipLoader';

const LoadingButton = ({ isLoading, placeholder, newSize, color, btnTextColor }) => (
  <Fragment>
    {isLoading ? (
      <ClipLoader sizeUnit={'px'} size={newSize ? newSize : 24} color={color ? color : '#fff'} />
    ) : (
      <span style={{ color: btnTextColor ? btnTextColor : 'white' }}>{placeholder}</span>
    )}
  </Fragment>
); // END LoadingButton

LoadingButton.propTypes = {
  isLoading: PropTypes.bool,
  placeholder: PropTypes.string,
  newSize: PropTypes.any,
  color: PropTypes.any,
  btnTextColor: PropTypes.any
};

export default LoadingButton;



// WEBPACK FOOTER //
// ./src/components/LoadingButton.js